/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{width:100%;height:100%}.home-content-block[_ngcontent-%COMP%]   .content-block[_ngcontent-%COMP%]{font-size:large!important}.home-content-block[_ngcontent-%COMP%]   .emphasis[_ngcontent-%COMP%]{font-weight:900}"];
export { styles as styles };
